import React from 'react';
import { useBuildoutOsDisplay } from 'components/buildout_os_display';

type Props = {
  isHidden?: boolean,
  text: string,
  value: string | number,
}

export default function BasicCard({
  isHidden, text, value,
}: Props) {
  const buildoutOs = useBuildoutOsDisplay();

  if (buildoutOs) {
    return (
      <div className={`ds-client-report-tile border h-100 p-3 ${isHidden ? 'ds-client-report-text--hidden' : ''}`}>
        <div className="ds-client-report-tile-label text-muted text-truncate">{text}</div>
        <div className="ds-client-report-tile-value fw-bold mt-1">
          {typeof value === 'number' ? value.toLocaleString() : value}
        </div>
      </div>
    );
  }

  const textClasses = [
    'ds-client-report-text',
    'd-flex',
    'align-items-center',
    'justify-content-center',
    'flex-grow',
    isHidden ? 'ds-client-report-text--hidden' : '',
  ].join(' ');

  return (
    <div className="ds-client-report-card d-flex">
      <div className="ds-client-report-value align-items-center justify-content-center d-flex py-3 px-4">
        <div>{value}</div>
      </div>
      <div
        className={`${textClasses} flex-fill`}
      >
        {text}
      </div>
    </div>
  );
}
